import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-train-daily-goal-progress',
  imports: [NgbTooltipModule],
  templateUrl: './train-daily-goal-progress.html',
  styleUrl: './train-daily-goal-progress.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrainDailyGoalProgress {
  readonly reviewedCards = input(0);
  readonly dailyCardsTarget = input(0);
  readonly segmentCount = input(12);
  readonly ariaLabel = input('');
  readonly tooltip = input('');

  protected readonly segments = computed(() =>
    Array.from({ length: this.resolvedSegmentCount() }, (_, index) => index),
  );
  protected readonly segmentCountStyle = computed(() =>
    String(this.resolvedSegmentCount()),
  );
  protected readonly filledSegmentCount = computed(() => {
    const target = this.dailyCardsTarget();
    if (target <= 0) {
      return 0;
    }

    const percent = this.clamp(this.reviewedCards() / target, 0, 1);
    return Math.min(
      this.resolvedSegmentCount(),
      Math.ceil(percent * this.resolvedSegmentCount()),
    );
  });
  protected readonly valueNow = computed(() =>
    this.clamp(Math.round(this.reviewedCards()), 0, this.valueMax()),
  );
  protected readonly valueMax = computed(() =>
    Math.max(0, Math.round(this.dailyCardsTarget())),
  );
  protected isSegmentFilled(index: number): boolean {
    return index < this.filledSegmentCount();
  }

  private resolvedSegmentCount(): number {
    return Math.max(1, Math.round(this.segmentCount()));
  }

  private clamp(value: number, min: number, max: number): number {
    return Math.max(min, Math.min(max, value));
  }
}
